import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../components/typography';
import Card from '../../icons/williamhill/card';
import { GreenText, Or, RedText, VerticalLine } from '../components';
import InsertRemoveCard from '../../icons/williamhill/insert-remove-card';

export default function Kiosk() {
  return (
    <Container>
      <Text size="lg" weight="bold" style={{ width: '16.6rem' }}>
        <GreenText>Insert</GreenText> then <RedText>remove</RedText> your card in the slot below to activate.
      </Text>
      <Or />
      <Text size="lg" weight="bold" style={{ width: '22.9rem' }}>
        Enter the number shown on your rewards card.
      </Text>

      <InsertRemoveCard />
      <VerticalLine />
      <Card />
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  padding: 3rem 11rem;
  width: 80.2rem;
  gap: 3rem;
  grid-template-columns: 1fr 32px 1fr;
  grid-template-rows: 7rem auto;
  justify-items: center;
`;
